
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PrincipalConfirmationForm.html?raw';
import { ExpandableSection, ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import "../../moreCore/UI/RadioGroup/RadioGroup";
import "../../moreCore/UI/SelectBox/SelectBox";
import "../../moreCore/UI/Tabbing/PageStack";
import Edit from '../../moreCore/UI/Edit/Edit';
import { OMtypes } from "../_loadingHelpers/OM";
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import { EmploymentPropositionTypes } from "./OE_Types";
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
//import ExpandableSection = require("../../moreCore/UI/Container/ExpandableSection");
import PrincipalConfirmationInput from './PrincipalConfirmationInput';


interface FormData {
    employmentPropositions: Array<{
        employmentPropositionID: string,
        confirmationDutyTypeID: string
    }>
}

interface ConfirmationSetupData{
    evProject: VAM2types.EvProjectEntity_Base;
    functionalGroupPropositions: Array<EmploymentPropositionTypes.EmploymentPropositionEntity>;
    //plannedMusician: OMtypes.plannedMusician;
    //orchestraEmployments: Array<OMtypes.orchestraEmployment>;
}

class PrincipalConfirmationForm extends compose(_uiFrameMixin) {
    templateString: any = template;

    inputDutyType: MdsLax<InstanceType<typeof RadioGroup>>;
    inputNote: MdsLax<InstanceType<typeof Edit>>;
    errorMessageContainer: HTMLElement;
    errorMessage: HTMLElement;

    private headingNode: HTMLElement;

    private projectView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private projectViewContainer: HTMLElement;
    private propositionView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private propositionViewContainer: HTMLElement;
    private employmentsView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private employmentsViewContainer: HTMLElement;

    private pageStack: MdsLax<InstanceType<typeof PageStack>>;

    private _availableDutyTypes: Array<OMtypes.dutyType>;

    private entityData_evProject: VAM2types.EvProjectEntity_Base = null;
    private entityData_employmentPropositions: Array<EmploymentPropositionTypes.EmploymentPropositionEntity> = null;
    private functionalGroupID: string = null;
    private projectID: string = null;

    private entityViewProject: MdsLax<InstanceType<typeof GenericEntityView>>;
    private entityViewDuty: MdsLax<InstanceType<typeof GenericEntityView>>;

    private isReadOnly: boolean = true;

    private propositionsExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private propositionsContainer: HTMLDivElement;

    private principalConfirmationInputs: Array<MdsLax<InstanceType<typeof PrincipalConfirmationInput>>> = [];


    setup(functionalGroupID: string, projectID: string) {
        if (!functionalGroupID || !projectID) {
            return;
        }

        this.functionalGroupID = functionalGroupID;
        this.projectID = projectID;

    }

    
    private _loadFormData(functionalGroupID: string, projectID: string) {
        if (!functionalGroupID || !projectID) {
            return;
        }

        this.StandbyStart();

        let data = {
            functionalGroupID: functionalGroupID,
            projectID: projectID
        };

        this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentProposition__GetConfirmationsFormData",
            data,
            lang.hitch(this, this._onLoadFormDataResponse),
            lang.hitch(this, this._onLoadFormDataError),
        );
    }

    private _onLoadFormDataResponse(response: ConfirmationSetupData) {

        this.setData(response);

        this.StandbyStop();
    }

    private _onLoadFormDataError(error: more.requestErrorMessage) {
        this.StandbyStop();
    }

    private setReadonly(isReadonly: boolean) {
        this.isReadOnly = isReadonly;
        if (isReadonly) this.removeButton("save");
        else this.createDefaultButton("save", lang.hitch(this, this._onClickSave));
        
        for (var input of this.principalConfirmationInputs) {
            input.setReadOnly(isReadonly);
        }
    }


    private setData(entity: ConfirmationSetupData): void {

        this.UiModder.domConstruct.empty(this.propositionsContainer);

        this.entityData_evProject = entity.evProject;

        
        
        this.UiModder.domConstruct.empty(this.projectViewContainer);
        this.projectView = null;

        //DERZEIT NICHT GENUTZT
        if (this.employmentsViewContainer) this.UiModder.domConstruct.empty(this.employmentsViewContainer);
        this.employmentsView = null;

        this.pageStack.disablePage("project");
        this.pageStack.disablePage("employments");


        if (entity.evProject) {
            this.projectView = new GenericEntityView();
            this.projectView.setup(this.entityData_evProject.ID,
                this.entityData_evProject.Classname,
                this.entityData_evProject.gDisp_1,
                null,
                this.projectViewContainer,
                null,
                "employmentPropositionForm");

            let isReadonly = entity.evProject.status_orchester_employment_registration !== 2;
            this.setReadonly(isReadonly);
            this.pageStack.enablePage("project");
        }

        if (entity.functionalGroupPropositions) {
            for (var proposition of entity.functionalGroupPropositions) {
                var confirmationInput = new PrincipalConfirmationInput();
                confirmationInput.setReadOnly(this.isReadOnly);
                confirmationInput.on("changed", lang.hitch(this, this._onChange_Generic));
                this.principalConfirmationInputs.push(confirmationInput);
                confirmationInput.setup(proposition);
                confirmationInput.placeAt(this.propositionsContainer)
            }
            this.propositionsExpander.setMarking(ExpandableSectionMarkings.hasContent);
        }

        //this.setReadonly(this.isReadOnly);

        

        this.pageStack.activatePageByName("project");

        this.serializeData();
    }

    private checkMandatory(): boolean {
        let dutyTypeValue = this.inputDutyType.getValue();

        if (!dutyTypeValue) {
            return false;
        }

        return true;
    }

    private serializeData() {
        let data: FormData = {
            employmentPropositions: [],
        };

        for (var proposition of this.principalConfirmationInputs) {
            data.employmentPropositions.push({
                employmentPropositionID: proposition.getData().employmentPropositionID,
                confirmationDutyTypeID: proposition.getData().confirmationDutyTypeID
            })
        }

        return data;
    }

    //getFormData(): FormData | false {
    //    // ist alles ausgefüllt?
    //    if (!this.checkMandatory()) return null;

    //    // Inputs auslesen und serialisieren...
    //    let data = this.serializeData();
    //    return data;
    //}

    private _onChange_Generic(e: Event) {
        this.serializeData();

        this.enableButton("save");
    }

   
    private getDutyTypeById(ID: string): OMtypes.dutyType {
        let dutyTypes = this._availableDutyTypes;
        if (dutyTypes) {
            for (let dutyType of dutyTypes) {
                if (ID == dutyType.ID) {
                    return dutyType;
                }
            }
        }

        return null;
    }

    protected onShow() {
        this.UiModder.domAttr.set(this.headingNode, "innerHTML", this.title);
        this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false);

        this._loadFormData(this.functionalGroupID, this.projectID);
    }

    private _onClickSave(): void {
        var data = this.serializeData();

        this.StandbyStart();

        this.RequestManager.callfunction("Webtool_API_OrchestraEmploymentProposition__SaveConfirmation", data, lang.hitch(this, this._onSaveResponse), lang.hitch(this, this._onSaveError));
    }

    private _onSaveResponse(response): void {

        this.StandbyStop();

        this._loadFormData(this.functionalGroupID, this.entityData_evProject.ID);
        this.requestContextButtonDisable("save");
    }

    private _onSaveError(error): void {
        this.StandbyStop();
        console.error(error);
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setReadonly(true);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.loadDutyTypes();
    }
}

export default mdsWidget(PrincipalConfirmationForm);
